import { render, staticRenderFns } from "./UserBeacons.vue?vue&type=template&id=6625b58c&"
import script from "./UserBeacons.vue?vue&type=script&lang=js&"
export * from "./UserBeacons.vue?vue&type=script&lang=js&"
import style0 from "./UserBeacons.vue?vue&type=style&index=0&id=6625b58c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports